import { render } from "./stronaKonta.vue?vue&type=template&id=f6b8d39a&scoped=true"
import script from "./stronaKonta.vue?vue&type=script&lang=js"
export * from "./stronaKonta.vue?vue&type=script&lang=js"

import "./stronaKonta.vue?vue&type=style&index=0&id=f6b8d39a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b8d39a"]])

export default __exports__